import React from 'react';
import { LcaCustomResultModel, Option } from 'types/types';

import { CustomResultValidateButtonPressed } from '../../Step3';
import LcaCustomResultPanel from './LcaCustomResultPanel';

type LcaCustomResultsSectionProps = {
  epdVersionId: string;
  lcaCustomResults: LcaCustomResultModel[];
  additionalPerformanceResultsTypes: Option[];
  scenariosLookup: Option[];
  isReadOnly: boolean;
  errors: any;
  customResultButtonPressed: CustomResultValidateButtonPressed[];
  setCustomResultButtonPressed: any;
  onDeleteCustomResult: (id: string) => void;
  onChangedCustomResult: (customResult: LcaCustomResultModel) => (propertyName: string, val: any) => void;
};

const LcaCustomResultsSection: React.FunctionComponent<LcaCustomResultsSectionProps> = ({
  epdVersionId,
  lcaCustomResults,
  additionalPerformanceResultsTypes,
  scenariosLookup,
  isReadOnly,
  errors,
  customResultButtonPressed,
  setCustomResultButtonPressed,
  onDeleteCustomResult,
  onChangedCustomResult,
}) => {
  const shouldCustomResultTableErrorsBeShown = (customResultId: string) => {
    return customResultButtonPressed.some((btn) => btn.id === customResultId && btn.isValidateBtnPressed);
  };

  const showCustomResultErrors = (customResultId: string) => {
    setCustomResultButtonPressed((prev: CustomResultValidateButtonPressed[]) => [
      ...prev,
      { id: customResultId, isValidateBtnPressed: true } as CustomResultValidateButtonPressed,
    ]);
  };

  return (
    <>
      {lcaCustomResults.map((customResult: LcaCustomResultModel) => {
        const title =
          additionalPerformanceResultsTypes.find((x) => x.value == customResult.resultType)?.label ??
          'Additional environmental performance results';

        return (
          <LcaCustomResultPanel
            key={customResult.id}
            customResult={customResult}
            title={title}
            epdVersionId={epdVersionId}
            isReadOnly={isReadOnly}
            additionalPerformanceResultsTypes={additionalPerformanceResultsTypes}
            scenariosLookup={scenariosLookup}
            customResultError={errors?.[`lcaCustomResult_${customResult.id}`]}
            shouldShowTableErrors={shouldCustomResultTableErrorsBeShown(customResult.id)}
            onDeleteCustomResult={onDeleteCustomResult}
            onChangedCustomResult={onChangedCustomResult}
            onShowCustomResultErrors={showCustomResultErrors}
          />
        );
      })}
    </>
  );
};

export default LcaCustomResultsSection;
